/* global axios */
import ApiClient from '../ApiClient';

// Fase 59 — histórico financeiro de um card do Pipeline. Cada linha é uma venda
// registrada quando o card foi dado como ganho; um card acumula N delas.
//
// O caminho normal de registro é ganhar o card; aqui ficam a leitura do
// histórico e o ESTORNO, que precisa ser alcançável de onde o histórico é lido.
class PipelineOpportunitiesAPI extends ApiClient {
  constructor() {
    super('pipeline/cards', { accountScoped: true });
  }

  // Histórico do card, mais recente primeiro. O backend responde
  // { opportunities: [...], summary: {...}, meta: {...} } — o resumo vem pronto
  // para não somar no cliente uma lista paginada.
  list(cardId, { perPage, offset } = {}) {
    const params = {};
    // `per_page` é o nome que o contrato de paginação do Pipeline usa; mandar
    // `limit` fazia o servidor ignorar e devolver sempre a página padrão.
    if (perPage !== undefined) params.per_page = perPage;
    if (offset !== undefined) params.offset = offset;

    return axios.get(`${this.url}/${cardId}/opportunities`, { params });
  }

  // Estorno NÃO apaga: marca a linha e recalcula o acumulado do card. A venda
  // continua no histórico, com quem estornou, quando e por quê — é o que separa
  // uma correção de um sumiço.
  void(id, { reason } = {}) {
    return axios.post(
      `${this.baseUrl()}/pipeline/opportunities/${id}/void`,
      reason ? { reason } : {}
    );
  }

  // Relatório da cross feature Oportunidades (flag `pipeline_opportunities`):
  // agregado por moeda/funil/responsável/origem/dia, para a tela em
  // Relatórios › Oportunidades. `startDate`/`endDate` são DATAS de calendário
  // (YYYY-MM-DD) — quem decide onde o dia começa é o fuso da CONTA, resolvido
  // no servidor, igual ao endpoint de desempenho de produto.
  report({ startDate, endDate, pipelineId } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    if (pipelineId !== undefined && pipelineId !== null) {
      params.pipeline_id = pipelineId;
    }

    return axios.get(`${this.baseUrl()}/pipeline/opportunities/report`, {
      params,
    });
  }
}

export default new PipelineOpportunitiesAPI();
